import React from "react";
import AndroidImg from "../assests/images/android.png";
import IosImg from "../assests/images/ios.png";
import AppStoreBadge from "../assests/images/appStore.svg";
import GooglePlayBadge from "../assests/images/googleStore.svg";

const AppShowcase = () => {
  return (
    <section id="download" className="bg-white py-16 px-4 lg:px-20">
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="text-3xl font-bold text-gray-800 mb-3">
          Available on{" "}
          <span className="text-[#30D5C8]">iOS & Android</span>
        </h2>
        <p className="text-gray-500 mb-12 max-w-xl mx-auto">
          Download the Pepli app and connect with the arts & entertainment
          community on your device.
        </p>
        <div className="flex flex-col sm:flex-row justify-center items-center gap-8 sm:gap-16">
          {/* Android column */}
          <div className="flex flex-col items-center gap-4">
            <img
              src={AndroidImg}
              alt="Pepli Android QR Code"
              className="w-56 sm:w-64 rounded-2xl shadow-xl"
            />
            <a href="https://play.google.com/store/apps/details?id=com.pepli.app" target="_blank" rel="noopener noreferrer">
              <img
                src={GooglePlayBadge}
                alt="Get it on Google Play"
                className="h-12"
              />
            </a>
          </div>
          {/* iOS column */}
          <div className="flex flex-col items-center gap-4">
            <img
              src={IosImg}
              alt="Pepli iOS QR Code"
              className="w-56 sm:w-64 rounded-2xl shadow-xl"
            />
            <a href="https://apps.apple.com/us/app/pepli/id6464536675" target="_blank" rel="noopener noreferrer">
              <img
                src={AppStoreBadge}
                alt="Download on the App Store"
                className="h-12"
              />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppShowcase;
